/**
 * HelpIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const HelpIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12 6a3.85 3.85 0 0 1 2.67.82 2.93 2.93 0 0 1 .76 2.32c.002.444-.1.883-.3 1.28-.284.5-.645.953-1.07 1.34l-.64.62a2.15 2.15 0 0 0-.7 1.36v.49h-2a4.6 4.6 0 0 1 .28-1.78c.228-.508.57-.957 1-1.31.381-.3.718-.654 1-1.05.157-.256.24-.55.24-.85 0-.9-.41-1.35-1.24-1.35a1.27 1.27 0 0 0-.96.37 1.42 1.42 0 0 0-.37 1H8.35a3.09 3.09 0 0 1 1-2.4A3.86 3.86 0 0 1 12 6m-1.05 9.8a1.3 1.3 0 0 1 .93-.35 1.33 1.33 0 0 1 .93.35c.24.228.371.549.36.88a1.18 1.18 0 0 1-.35.87 1.3 1.3 0 0 1-.94.34 1.28 1.28 0 0 1-.94-.34 1.15 1.15 0 0 1-.36-.87 1.13 1.13 0 0 1 .37-.88" />
    <path
      fillRule="evenodd"
      d="M1 12C1 5.925 5.925 1 12 1a11 11 0 0 1 11 11c0 6.075-4.925 11-11 11S1 18.075 1 12m20 0a9 9 0 1 0-18 0 9 9 0 0 0 18 0"
      clipRule="evenodd"
    />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const HelpIcon = makeIcon('HelpIcon', HelpIconSvg)
